import { TicketAdapter as p } from "../../../ticket/ticket.adapter.js";
import { Adapter as i, getAdapter as o } from "../../../../adapter.js";
import { ShopSessionCheckoutModel as r } from "./checkout.model.js";
import { ShopSessionCheckoutFieldAdapter as c } from "./checkoutField/checkoutField.adapter.js";
import { ShopTicketAdapter as s } from "./shopTicket/shopTicket.adapter.js";
class f extends i {
  adapt(e) {
    const t = o(c);
    return new r({
      shopTicket: o(s).adapt(e == null ? void 0 : e.shop_ticket),
      ticket: o(p).adapt(e.ticket),
      checkoutFields: e.checkout_fields ? e.checkout_fields.map(t.adapt) : []
    });
  }
  serialize(e) {
  }
}
export {
  f as ShopSessionCheckoutAdapter
};
//# sourceMappingURL=checkout.adapter.js.map
